import type { TopicId } from "../types/dashboard";
import { groupCardsByRow, mobileCardsForTopic } from "../registry/mobileCardRegistry";

export function MobileMainArea({ topicId }: { topicId: TopicId }) {
  const cards = mobileCardsForTopic(topicId);
  const rows = groupCardsByRow(cards);

  return (
    <div className="flex flex-col gap-[var(--space-section)]">
      {[...rows.entries()].map(([rowKey, { label, cards: rowCards }]) => (
        <section key={rowKey}>
          {label && rowKey !== "hero" && (
            <h2 className="mobile-section-title">{label}</h2>
          )}
          <div className="flex flex-col gap-3">
            {rowCards.map((card) => (
              <div key={card.id}>{card.render()}</div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
